import { css } from '@emotion/core'
import styled from '@emotion/styled'
import React, { FunctionComponent } from 'react'
import { DataNotFound, DataNotFoundProps } from '../shared/DataNotFound'

type SectionDataNotFoundProps = Partial<DataNotFoundProps>

const SectionDataNotFound: FunctionComponent<SectionDataNotFoundProps> = ({
    title = 'No Data Added',
    iconName = 'no-data',
    description,
    children,
}) => {
    return (
        <DataNotFound
            title={title}
            description={description}
            iconName={iconName}
            css={css`
                margin-top: 12px;
            `}
        >
            {children}
        </DataNotFound>
    )
}

const SectionWrapper = styled.div`
    margin-top: 40px;
    margin-bottom: 48px;
`

export { SectionDataNotFound, SectionWrapper }
